function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.529,
  y: 7.18,
  width: 28.943,
  height: 6.834,
  rx: 1.333,
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.976 14.014h26.048v13.7c0 .737-.597 1.334-1.333 1.334H4.31a1.333 1.333 0 01-1.333-1.333v-13.7zM16 6.497v22.551M15.277 7.181c2.894-1.367 5.949-4.784 9.567-4.784 3.618 0 4.18 3.417 3.457 4.784",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.724 7.181c-2.895-1.367-5.517-4.784-9.568-4.784-3.617 0-4.18 3.417-3.457 4.784",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS41Mjg4MSIgeT0iNy4xNzk5MyIgd2lkdGg9IjI4Ljk0MjYiIGhlaWdodD0iNi44MzM2NyIgcng9IjEuMzMzMzMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTIuOTc2MDcgMTQuMDE0MkgyOS4wMjQ0VjI3LjcxNDlDMjkuMDI0NCAyOC40NTEzIDI4LjQyNzUgMjkuMDQ4MiAyNy42OTExIDI5LjA0ODJINC4zMDk0MUMzLjU3MzAzIDI5LjA0ODIgMi45NzYwNyAyOC40NTEzIDIuOTc2MDcgMjcuNzE0OVYxNC4wMTQyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8cGF0aCBkPSJNMTYgNi40OTcwN1YyOS4wNDgyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxwYXRoIGQ9Ik0xNS4yNzY2IDcuMTgxMDNDMTguMTcwOSA1LjgxNDMgMjEuMjI1OSAyLjM5NzQ2IDI0Ljg0MzggMi4zOTc0NkMyOC40NjE2IDIuMzk3NDYgMjkuMDI0NCA1LjgxNDMgMjguMzAwOCA3LjE4MTAzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxwYXRoIGQ9Ik0xNi43MjM2IDcuMTgxMDNDMTMuODI5NCA1LjgxNDMgMTEuMjA2NiAyLjM5NzQ2IDcuMTU2NDcgMi4zOTc0NkMzLjUzODY1IDIuMzk3NDYgMi45NzU4OSA1LjgxNDMgMy42OTk0NiA3LjE4MTAzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+Cjwvc3ZnPgo=";
export { SvgGift as ReactComponent };